import { Card, Button } from "@/src/components";
import { useBalances } from "@/src/hooks/useBalances";
import { useStake } from "@/src/hooks/useStake";
import { useAccount } from "wagmi";
import { toast } from "react-hot-toast";
import { useAirdrop } from "@/src/hooks";
import { Timer } from "@/src/components/deadlineTimer";

export const PendingAirdrop3 = () => {
  const { airdropAmount3, nextClaim3, totalAmount3, withdrawn3 } = useAirdrop();
  const { frbStakedBalance } = useBalances();
  const { onClaimAirdrop3 } = useStake();
  const { isConnected } = useAccount();

  const handleRewards = async () => {
    if (!isConnected) return;

    toast.promise(onClaimAirdrop3(), {
      loading: "Transaction is in progress",
      success: "Successfully claimed airdrop",
      error: (data) => data,
    });
  }
  return (
    <Card className="flex flex-col h-full">
      <div className="mb-3">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wider">Airdrop 3</h2>
      </div>
      {parseFloat(withdrawn3) > parseFloat(frbStakedBalance) && (
        <div className="rounded-lg bg-warning/10 border border-warning/20 px-3 py-2 mb-3">
          <p className="text-xs text-warning">Stake additional {(parseFloat(withdrawn3)-parseFloat(frbStakedBalance)).toFixed(2)} FRB to claim 100%</p>
        </div>
      )}
      <div className="space-y-0 divide-y divide-border/50 flex-1">
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Next Amount</span>
          <span className="text-lg font-bold text-foreground font-mono">
            {parseFloat(airdropAmount3).toFixed(2)} <span className="text-primary text-sm font-semibold">FRB</span>
          </span>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Next Claim</span>
          <span className="text-lg font-bold text-primary font-mono tracking-wider">
            {parseInt(nextClaim3) > 0 ? <Timer time={parseInt(nextClaim3)}/> : "00:00:00:00"}
          </span>
        </div>
        <div className="flex items-center justify-between py-2.5">
          <span className="text-sm text-muted-foreground">Total Pending</span>
          <span className="text-lg font-bold text-foreground font-mono">
            {parseFloat(totalAmount3).toFixed(2)} <span className="text-primary text-sm font-semibold">FRB</span>
          </span>
        </div>
      </div>
      <div className="mt-4">
        <Button onClick={handleRewards} disabled={parseFloat(airdropAmount3)===0 || parseFloat(nextClaim3) > Date.now()/1000 }>
          Claim Airdrop
        </Button>
      </div>
    </Card>
  );
};
